/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  useEffect,
  useState,
} from 'react';

import { useFormik } from 'formik';
import Lottie from "lottie-react";
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import {
  toAbsoluteUrl
} from '../../../../_metronic/helpers';

import coin from '../../../../_metronic/assets/animations/coin.json';


import CreateCreditCard from '../../CreditCard/CreateCreditCard';
import EditDocument from '../../Profile/components/EditDocument';

import {
  fetchCreditCards,
} from 'app/services/creditCard';

import {
  getMeInfo,
} from 'app/services/auth';

import {
  fetchCredits,
} from 'app/services/credits';

import {
  fetchScheduleAvailablePaymentMethods,
} from 'app/services/payments';

import {
  getBrandImage,
} from "../../../utils/Labels";

const SelectPayment = ({
  branchId = '',
  modality = '',
  paymentMethod = '',
  disableCredit = true,
  onSelect,
  type = '',
  disableAll = false,
  disablePix = false,
  startAt = '',
  duration = '',
  serviceId = ''
}) => {
  const { creditCards } = useSelector((state : any) => ({
    creditCards: state.creditCards,
  }), shallowEqual);

  const dispatch = useDispatch();
  const [payment, setPayment] = useState<any>({});
  const [credit, setCredit] = useState<any>({});

  const [openCreateCreditCard, setOpenCreateCreditCard] = useState<any>(false);
  const [openEditDocument, setOpenEditDocument] = useState<any>(false);
  const [scheduleAvailablePaymentMethods, setScheduleAvailablePaymentMethods] = useState<any>({});

  useEffect(() => {
      getCredits();

      if (disableAll) {
        setPayment({
          paymentMethod: 'locally',
        });
      } else {
        setPayment({});
      }

      dispatch<any>(fetchCreditCards());
  }, []);

  useEffect(() => {
    if (
      creditCards.entities &&
      creditCards.entities.length > 0 &&
      !disableAll &&
      !credit?.id &&
      payment.paymentMethod !== 'credit_card'
    ) {
      setPayment({
        paymentMethod: 'credit_card',
        card: creditCards.entities[0],
      });
    }
  }, [creditCards]);

  useEffect(() => {
    getPayments();
  }, [branchId, type, modality, paymentMethod]);

  useEffect(() => {
    onSelect(payment);
  }, [payment]);

  useEffect(() => {
    if (!disablePix) {
      setPayment({
        paymentMethod: 'pix',
      });
    }
  }, [disablePix]);

  const getPayments = () => {
    if (
      branchId &&
      type === 'schedule' &&
      modality === 'single' &&
      paymentMethod === 'create'
    ) {
      dispatch<any>(fetchScheduleAvailablePaymentMethods(branchId)).then((data: any) => {
        setScheduleAvailablePaymentMethods(data.attributes);
      })
    }
  }

  const verifyOpenCreateCreditCard = () => {
    dispatch<any>(getMeInfo()).then((data: any) => {
      if (data && data.attributes && data.attributes.document) {
        setOpenCreateCreditCard(true);
      } else {
        setOpenEditDocument(true);
      }
    }).catch(() => {
      setOpenCreateCreditCard(true);
    })
  }

  const getCredits = () => {
    if (!disableAll && !disableCredit && serviceId && duration && startAt) {
      dispatch<any>(fetchCredits(serviceId, duration, 'active', startAt)).then((data: any) => {
        // let defaultPayment: any = {
        //   image: 'pix',
        //   paymentMethod: 'pix',
        // };

        if (data.length > 0) {
          setCredit({
            count: data.length,
            id: data[0].id,
            name: data[0].relationships.origin.attributes.name
          });

          setPayment({
            image: 'credit',
            paymentMethod: 'credit',
            creditId: data[0].id
          });
        }
      });
    }
  }

  const closeCreateCreditCard = () => {
    setOpenCreateCreditCard(false);
  }

  const formik = useFormik<any>({
    initialValues: {
      email: '',
      password: '',
    },
    onSubmit: (values) => {
      //
    },
  })

  const choosePayment = (value) => {
    setPayment(value);
  }

  return (
    <>
      <div className="current" data-kt-stepper-element="content">
        <div className="w-100">
          {!disableCredit && scheduleAvailablePaymentMethods?.v1 && <div className="fv-row mb-5">
            <label
              className={`btn btn-outline btn-outline-dashed btn-active-light-primary d-flex text-start p-5 mb-3 ${payment && payment.paymentMethod == 'locally' && 'active'}`}
              onClick={() => choosePayment({
                paymentMethod: 'locally',
              })}
            >
              <input className="btn-check" type="radio" checked={true} name="offer_type" value="1" />
              <span className="d-flex">
                <span className="svg-icon svg-icon-3hx d-flex flex-column align-items-center justify-content-center">
                  <img src={toAbsoluteUrl('/media/custom/image_money.png')} width="25" alt='Pagamento no local' />
                </span>
                <span className="ms-4">
                  <span className="fs-5 fw-bold text-gray-900 mb-1 d-block">Pagamento no local</span>
                  <span className="fw-semibold fs-6 text-gray-600">Efetue o pagamento na unidade</span>
                </span>
              </span>
            </label>
          </div>}

          {!disableCredit && credit.count > 0 && <div className="fv-row mb-5">
            <label
              className={`btn btn-outline btn-outline-dashed btn-active-light-primary d-flex text-start p-5 mb-3 ${payment && payment.paymentMethod == 'credit' && 'active'}`}
              onClick={() => choosePayment({
                image: 'credit',
                paymentMethod: 'credit',
                creditId: credit.id
              })}
            >
              <input className="btn-check" type="radio" checked={true} name="offer_type" value="1" />
              <span className="d-flex">
                <span className="d-flex flex-column align-items-center justify-content-center">
                  {/* <img src={toAbsoluteUrl('/media/custom/image_money.png')} width="25" alt='Pagamento com crédito' /> */}
                  <Lottie
                    style={{
                      height: 50,
                      width: 50,
                      marginLeft: '-10px',
                    }}
                    animationData={coin}
                    autoplay
                    loop={false}
                  />
                </span>
                <span className="ms-1">
                  <span className="fs-5 fw-bold text-gray-900 mb-1 d-block">{credit.count} {credit.count > 1 ? `créditos disponíveis` : `crédito disponível`}</span>
                  <span className="fw-semibold fs-6 text-gray-600">{credit.name}</span>
                </span>
              </span>
            </label>
          </div>}

          {!disableAll && <>
            {!disablePix && <div className="fv-row mb-5">
              <label
                className={`btn btn-outline btn-outline-dashed btn-active-light-primary d-flex text-start p-5 mb-3 ${payment && payment.paymentMethod == 'pix' && 'active'}`}
                onClick={() => choosePayment({
                  paymentMethod: 'pix',
                })}
              >
                {/*<input className="btn-check" type="radio"  name="offer_type" value="1" />*/}
                <span className="d-flex">
                  <span className="svg-icon svg-icon-3hx d-flex flex-column align-items-center justify-content-center">
                    <img src={toAbsoluteUrl('/media/custom/pix.png')} width="25" alt='Pix' />
                  </span>
                  <span className="ms-4">
                    <span className="fs-5 fw-bold text-gray-900 mb-1 d-block">Pague com pix</span>
                    <span className="fw-semibold fs-6 text-gray-600">Use o QR Code ou copie e cole o código</span>
                  </span>
                </span>
              </label>
            </div>}

            {creditCards && creditCards.entities && creditCards.entities.map(card => <div className="fv-row mb-5">
              <label
                className={`btn btn-outline btn-outline-dashed btn-active-light-primary d-flex text-start p-5 mb-3 ${payment && payment.card?.id == card.id && 'active'}`}
                onClick={() => choosePayment({
                  paymentMethod: 'credit_card',
                  card: card,
                })}
              >
                {/*<input className="btn-check" type="radio" name="offer_type" value="1" />*/}
                <span className="d-flex">
                  <span className="svg-icon svg-icon-3hx d-flex flex-column align-items-center justify-content-center">
                    <img src={toAbsoluteUrl(`/media/custom/${getBrandImage(card.attributes.brand)}`)} width="25" alt='Pix' />
                  </span>
                  <span className="ms-4">
                    <span className="fs-5 fw-bold text-gray-900 mb-1 d-block">{card.attributes.label ?? card.attributes.brand} • Crédito</span>
                    <span className="fw-semibold fs-6 text-muted">••• {card.attributes.last_four_digits}</span>
                  </span>
                </span>
              </label>
            </div>)}

            <div className="fv-row mb-5">
              <button
                id="create-credit-card-button"
                type="button"
                // className="btn btn-lg fw-bold border-2 border-gray-900 "
                className="btn btn-lg fw-bold btn-secondary btn-active-light-primary w-100 mb-5"
                onClick={() => verifyOpenCreateCreditCard()}
              >
                <span className="indicator-label">CADASTRAR CARTÃO</span>
              </button>
            </div>
          </>}
        </div>
      </div>

      <CreateCreditCard
        isOpen={openCreateCreditCard}
        onClosed={() => closeCreateCreditCard()}
      />

      <EditDocument
        isOpen={openEditDocument}
        onClosed={() => setOpenEditDocument(false)}
      />
    </>
  )
}

export default SelectPayment;
